import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  chip: {
    marginLeft: 10,
    marginTop: 10,
    ...reskinStyles(theme, { '&&': { ...theme.labelStyles.outlined, '& > span': { padding: 0 } } })
  },
  phonesWrapper: {
    marginTop: 25,
    marginBottom: 10
  },
  secondaryPhone: {
    marginBottom: 15
  }
}));

export default useStyles;
